// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Kw2GW","lds-ring":"Loading_lds-ring__gXpAP"};